// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  background: #fff;
  display: block;
}
:host.space-between-elements {
  margin-bottom: 15px !important;
  border-bottom: 0px solid var(--ion-color-light);
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.1);
}
:host.space-between-elements:last-of-type {
  margin-bottom: 0px !important;
}
:host h3 {
  margin-bottom: 10px;
}
:host .is-video {
  position: relative;
  width: 100%;
  height: auto;
}
:host .is-video .icon-play {
  background-color: white;
  border-radius: 50%;
  height: 50px;
  width: 50px;
  top: calc(50% - 35px);
  padding: 10px 7px 10px 13px;
  left: calc(50% - 35px);
  position: absolute;
  box-shadow: 0px 0px 10px -2px var(--ion-color-dark);
  color: var(--ion-color-dark);
}
:host .is-video img {
  height: auto;
}
:host ion-item.item.space-between-elements {
  margin-bottom: 15px !important;
  border-bottom: 0px solid var(--ion-color-light);
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.1);
}
:host ion-item.item ion-label {
  display: flex;
  flex-direction: column;
  margin: 0;
  white-space: pre-wrap;
}
:host ion-item.item ion-label .content {
  padding: var(--small-item-padding);
}
:host ion-item.item ion-label .content h3 {
  word-wrap: normal;
  white-space: normal;
  line-height: 1.2;
}
:host ion-item.item ion-label .content .text-and-icon {
  display: flex;
  white-space: pre-wrap;
}
:host ion-item.item ion-label .content small {
  color: var(--ion-color-medium);
  margin-bottom: 20px;
  display: flex;
  width: 100%;
  justify-content: space-between;
}
:host ion-item.item ion-label .content p {
  word-wrap: normal;
  color: var(--ion-color-dark);
  line-height: 1.5;
}`, "",{"version":3,"sources":["webpack://./src/app/components/blog-item/blog-item.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EAcA,cAAA;AAZF;AADE;EACE,8BAAA;EACA,+CAAA;EACA,0CAAA;AAGJ;AAFI;EACE,6BAAA;AAIN;AAAE;EACE,mBAAA;AAEJ;AAGE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AADJ;AAEI;EACE,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,2BAAA;EACA,sBAAA;EACA,kBAAA;EACA,mDAAA;EACA,4BAAA;AAAN;AAEI;EACE,YAAA;AAAN;AAKI;EACE,8BAAA;EACA,+CAAA;EACA,0CAAA;AAHN;AAMI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,qBAAA;AAJN;AAMM;EACE,kCAAA;AAJR;AAMQ;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;AAJV;AAOQ;EACE,aAAA;EACA,qBAAA;AALV;AAQQ;EACE,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,8BAAA;AANV;AASQ;EACE,iBAAA;EACA,4BAAA;EACA,gBAAA;AAPV","sourcesContent":[":host {\n  background: #fff;\n  &.space-between-elements {\n    margin-bottom: 15px !important;\n    border-bottom: 0px solid var(--ion-color-light);\n    box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.1);\n    &:last-of-type {\n      margin-bottom: 0px !important;\n    }\n  }\n\n  h3 {\n    margin-bottom: 10px;\n  }\n\n  display: block;\n\n  .is-video {\n    position: relative;\n    width: 100%;\n    height: auto;\n    .icon-play {\n      background-color: white;\n      border-radius: 50%;\n      height: 50px;\n      width: 50px;\n      top: calc(50% - 35px);\n      padding: 10px 7px 10px 13px;\n      left: calc(50% - 35px);\n      position: absolute;\n      box-shadow: 0px 0px 10px -2px var(--ion-color-dark);\n      color: var(--ion-color-dark);\n    }\n    img {\n      height: auto;\n    }\n  }\n\n  ion-item.item {\n    &.space-between-elements {\n      margin-bottom: 15px !important;\n      border-bottom: 0px solid var(--ion-color-light);\n      box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.1);\n    }\n\n    ion-label {\n      display: flex;\n      flex-direction: column;\n      margin: 0;\n      white-space: pre-wrap;\n\n      .content {\n        padding: var(--small-item-padding);\n\n        h3 {\n          word-wrap: normal;\n          white-space: normal;\n          line-height: 1.2;\n        }\n\n        .text-and-icon {\n          display: flex;\n          white-space: pre-wrap;\n        }\n\n        small {\n          color: var(--ion-color-medium);\n          margin-bottom: 20px;\n          display: flex;\n          width: 100%;\n          justify-content: space-between;\n        }\n\n        p {\n          word-wrap: normal;\n          color: var(--ion-color-dark);\n          line-height: 1.5;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
